module.exports = {
    //Common Button
    "TNC_BTN_SEARCH": "ค้นหา",
    "TNC_BTN_CLEAR": "ล้างข้อมูล",
    "TNC_BTN_ADD": "เพิ่ม",

    "TNC_ACTIVE": "ใช้งาน",
    "TNC_INACTIVE": "ไม่ใช้งาน",
}
